/**
 * EmptyState Component
 *
 * Friendly empty state component for when there's no content to display.
 *
 * Usage:
 * <EmptyState
 *   icon={<Icon />}
 *   title="No APIs found"
 *   description="Get started by subscribing to an API"
 *   action={<button>Browse Catalog</button>}
 * />
 */

import React, { ReactNode } from 'react';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}
    >
      {icon && (
        <div className="mb-4 text-gray-400" style={{ fontSize: '3rem' }}>
          {icon}
        </div>
      )}

      <h3
        className="text-gray-900 dark:text-white mb-2"
        style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-lg)',
          fontWeight: 'var(--font-semibold)',
        }}
      >
        {title}
      </h3>

      {description && (
        <p
          className="text-gray-600 dark:text-gray-400 max-w-md mb-6"
          style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-sm)',
            lineHeight: 'var(--leading-relaxed)',
          }}
        >
          {description}
        </p>
      )}

      {action && <div className="mt-4">{action}</div>}
    </div>
  );
};
